import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Custom hook for responsive design breakpoints
 * Returns boolean flags for different screen sizes
 */
export default function useResponsive() {
  const theme = useTheme();
  
  return {
    // Mobile: < 600px
    isMobile: useMediaQuery(theme.breakpoints.down('sm')),
    
    // Tablet: 600px - 900px
    isTablet: useMediaQuery(theme.breakpoints.between('sm', 'md')),
    
    // Desktop: >= 900px
    isDesktop: useMediaQuery(theme.breakpoints.up('md')),
    
    // Large Desktop: >= 1200px
    isLargeDesktop: useMediaQuery(theme.breakpoints.up('lg')),
    
    // Specific breakpoint checks
    isXs: useMediaQuery(theme.breakpoints.only('xs')),
    isSm: useMediaQuery(theme.breakpoints.only('sm')),
    isMd: useMediaQuery(theme.breakpoints.only('md')),
    isLg: useMediaQuery(theme.breakpoints.only('lg')),
    isXl: useMediaQuery(theme.breakpoints.only('xl')),
    
    // Utility: Check if mobile or tablet (not desktop)
    isMobileOrTablet: useMediaQuery(theme.breakpoints.down('md')),
  };
}
